import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Settings as SlickSettings } from "react-slick";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { BREAKPOINTS } from "web/react/constants";
import { Image } from "web/react/pages/product/product-image-gallery/product-gallery-image";
import { ProductImageGalleryCarouselEmo } from "web/react/pages/product/product-image-gallery/product-image-carousel-emo";
import * as styles from "web/react/pages/product/product-image-gallery/product-image-gallery.css";
import { sendAnalyticsEvent } from "web/react/pages/product/product-image-gallery/utils";
import { ProductCardSerializer } from "web/types/serializers";

interface FullscreenGalleryEmoProps {
    onClose: () => void;
    images: Image[];
    isOpen?: boolean;
    moreLikeThisProducts?: ProductCardSerializer[];
    currentLinkId?: string;
    currentSlideIndex: number;
    productId: string;
    buyOptionId: string;
    onSlideChange: (currentSlide: number, nextSlide: number) => void;
    initialSlideIndex: number;
    isInStockProductPage?: boolean;
}

interface ModalProps {
    children: React.ReactNode;
    onClose: () => void;
    in: boolean;
}

function ModalEmo({ children, onClose }: ModalProps): JSX.Element {
    return ReactDOM.createPortal(
        <div className={styles.overlay} data-testid="fullscreen-gallery">
            <div onClick={onClose} className={styles.close}>
                <SVGIcon name={"cross-thin"} />
            </div>
            {children}
        </div>,
        document.body
    );
}

function FullscreenGalleryEmo({
    isOpen = false,
    onClose,
    images,
    currentSlideIndex,
    productId,
    buyOptionId,
    onSlideChange,
    initialSlideIndex,
    isInStockProductPage = false,
}: FullscreenGalleryEmoProps): React.ReactElement {
    useEffect(() => {
        if (isOpen) {
            sendAnalyticsEvent("open_fullscreen", true, productId, buyOptionId);
        }
    }, [isOpen, productId, buyOptionId]);

    // Slick settings and props for the fullscreen gallery
    const slickSettings: SlickSettings = {
        accessibility: true,
        speed: 500,
        slidesToShow: 1,
        dots: images.length > 1,
        initialSlide: initialSlideIndex,
        beforeChange: onSlideChange,
        centerMode: false,
        touchThreshold: 5,
        infinite: false,
        swipeToSlide: true,
        arrows: false,
        swipe: true,
        touchMove: false,
        draggable: false,
        responsive: [
            {
                breakpoint: BREAKPOINTS.Medium,
                settings: {
                    speed: 200,
                    touchMove: true,
                    draggable: true,
                },
            },
        ],
    };

    return (
        <ModalEmo onClose={onClose} in={isOpen}>
            <ProductImageGalleryCarouselEmo
                images={images}
                isFullscreen={true}
                settings={slickSettings}
                onClose={onClose}
                currentSlideIndex={currentSlideIndex}
                isInStockProductPage={isInStockProductPage}
            />
        </ModalEmo>
    );
}

export default FullscreenGalleryEmo;
